<template>
  <interview-layout :touch-and-validate="touchAndValidate">
    <!-- inner wrapper used for centering -->
    <div class="">
      <!-- title above form card -->
      <h1 class="px-4 pb-3 fade-in-up-enter-active animation-slowest max-100 text-primary">Hypotheek</h1>
      <h5 class="px-4 pb-3 fade-in-up-enter-active animation-slowest delay-200 max-100">Uw hypotheek aanpassen</h5>
      <div class="d-flex flex-column flex-lg-row justify-content-center">

        <!-- form 1 card -->
        <base-card inner-class="container-narrow w-100" color="alternate" :outer-padding="true">
          <base-form @submit="onSubmit">

            <h6 class="pb-3 mt-3 max-100">Isolatiebudget Rabobank</h6>
            <div class="small mb-4">
                <checkmark-item class="mb-2" icon="info-circle-fill">
                  Heeft je huis <strong>energielabel E, F of G?</strong>
                </checkmark-item>
                <checkmark-item class="mb-2" icon="info-circle-fill">
                  Dan krijgt u &euro; 1.000 isolatiebudget.
                </checkmark-item>
                <checkmark-item class="mb-2" icon="info-circle-fill">
                  Een energieadviseur komt op bezoek en geeft advies om je huis energiezuiniger te maken. De energieadviseur bepaalt het huidige energielabel van je huis.
                </checkmark-item>
                <i class="mb-2">
                  Meer informatie vindt u op <a href="https://www.rabobank.nl/particulieren/hypotheek/duurzaam-wonen/isolatiebudget/aanmelden" target="_blank">Rabobank.nl</a>.
                </i>
            </div>
            
            <base-input
              class="mt-5"
              type="radiobuttons" :options="yesNo"
              name="HasRaboMortgageAndLabelFG"
              v-model:value="lead.financing.mortgage.HasRaboMortgageAndLabelFG" :validator="v$.financing.mortgage.HasRaboMortgageAndLabelFG">
              Heeft u een hypotheek bij de Rabobank en energielabel E, F of G?
            </base-input>

            <div v-if="lead.financing.mortgage.HasRaboMortgageAndLabelFG !== null">
              <h6 class="pb-3 mt-5 max-100">Aanpassen hypotheek (alle banken)</h6>
              <div class="small mb-4">
                  <checkmark-item class="mb-2" icon="info-circle-fill">
                    Vaak zijn er mogelijkheden om uw huidige hypotheek aan te passen, bijvoorbeeld door gebruik te maken van uw overwaarde.
                  </checkmark-item>
                  <checkmark-item class="mb-2" icon="info-circle-fill">
                    Hiermee kunt u mogelijk extra budget vrijmaken.
                  </checkmark-item>
              </div>


            <base-input
              class="mt-5 "
              type="radiobuttons" :options="yesNoInfo"
              name="WantUpdateMortgage"
              v-model:value="lead.financing.mortgage.WantUpdateMortgage" :validator="v$.financing.mortgage.WantUpdateMortgage">
              Wilt u gebruik maken van de mogelijkheden om uw hypotheek aan te passen?
            </base-input>

            </div>

          </base-form>
        <!-- form card end -->
        </base-card>
      
      <!-- cards wrapper end -->
      </div>
      <button-row class="mt-2 flex-row-reverse">
        <base-button class="ms-auto" icon="bi-arrow-right" @click="onSubmit" :disabled="v$.financing.mortgage.$invalid">Volgende</base-button>
        <base-button variant="minimal-secondary" icon="bi-arrow-left" icon-position="start" @click="onPrev">Terug</base-button>
      </button-row>
      <!-- inner wrapper end -->
    </div>
  </interview-layout>
</template>

<script>
  import InterviewLayout from "@/views/layouts/InterviewLayout.vue"
  import BaseCard from '@/components/BaseCard.vue'
  import BaseForm from "@/components/BaseForm.vue"
  import BaseInput from "@/components/BaseInput.vue"
  import BaseButton from "@/components/BaseButton.vue"
  import ButtonRow from "@/components/ButtonRow.vue"
  // import VariablePill from "@/components/VariablePill.vue"
  import CheckmarkItem from "@/components/CheckmarkItem.vue"
  // import IssueFeedback from "@/components/IssueFeedback.vue"

  import { useAllStores } from "@/helpers/UseAllStores"
  import { CommonComposable } from "@/helpers/CommonComposable"
  import { FlowService } from "@/services/FlowService"
  import { civilStatusOptions, ageBrackets, getSocialMinimum } from "@/services/SocialMinimumService"
  import { getAnnualMinimumWage, getMonthlyMinimumWage } from "@/helpers/MinimumWage"

  export default {
    components: {
      InterviewLayout,
      BaseCard,
      BaseForm,
      BaseInput,
      BaseButton,
      ButtonRow,
      // VariablePill,
      CheckmarkItem,
      // IssueFeedback
    },
    setup(props, context) {
      return { ...CommonComposable(props, context), ...useAllStores() };
    },
    data() {
      return {
        yesNo: [
          {
            label: 'Ja',
            value: true
          },
          {
            label: 'Nee',
            value: false
          },
        ],
        yesNoDontKnow: [
          {
            label: 'Ja',
            value: 'Ja'
          },
          {
            label: 'Nee',
            value: 'Nee'
          },
          {
            label: 'Weet ik niet',
            value: 'Weet ik niet'
          }
        ],
        moreLess: [
          {
            label: '- Lager',
            value: false
          },
          {
            label: 'Hoger +',
            value: true
          },
        ],
        yesNoInfo: [
          {
            label: 'Ja',
            value: 'Ja'
          },
          {
            label: 'Nee',
            value: 'Nee'
          },
          {
            label: 'Ik wil meer informatie',
            value: 'Ik wil meer informatie'
          }
        ],
        civilStatusOptions: civilStatusOptions,
        ageBrackets: ageBrackets
      };
    },
    computed: {
      socialMinimum() {
        const nipFields = this.lead.financing.nip;
        return getSocialMinimum(nipFields.AgeBracket, nipFields.AgeBracketPartner, nipFields.CivilStatus,  nipFields.HasChildren);
      },
      socialMinimum125() {
        // multiply by 1.25, round to 2 decimals, replace dot with comma
        return (this.socialMinimum * 1.25).toFixed(2).replace('.', ',');
      },
      monthlyWage125Pct() {
        let maxWage = getMonthlyMinimumWage(2023, 2, 1.25, true, 0);
        return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0 }).format(maxWage);
      },
      annualWage125Pct() {
        let maxWage = getAnnualMinimumWage(2023, 1.25, true, 0);
        return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0 }).format(maxWage);
      }
    },
    methods: {
      touchAndValidate() {
        this.v$.financing.mortgage.$touch();
        return !this.v$.financing.mortgage.$invalid;
      },
      onSubmit() {
        if (this.touchAndValidate()) {
          FlowService.pushNext(this);
        }
      },
      onPrev() {
        FlowService.pushPrev(this);
      }
    }
  }
</script>

<style lang="scss">
</style>